import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-guido-lib',
  template: `
    <p>
      guido-lib works!
    </p>
  `,
  styles: []
})
export class GuidoLibComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
